<template>
  <div>
    <el-dialog width="350px" :visible.sync="visible" title="该路径访问受限,需要身份验证" @close="close">
      <!-- 主体内容 -->
      <div class="authentication-container">
        <el-input-digit v-model.number="phoneVerifyCode" placeholder="填写验证码" :precision="0" style="width: 150px" />
        <el-button :disabled="isLock" @click="getVerificationCode">{{ phoneVerifyCodeText }}</el-button>
      </div>

      <div class="verify-code-info" v-if="phoneNum">验证码已发送至{{ phoneNum }}</div>

      <div class="authentication-btn-container">
        <el-button type="primary" @click="onSubmit" @keyup.native.enter="onSubmit">验 证</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPhoneCodeForTjSession, checkPhoneVerifyCodeForTj } from '@api/authentication.js';

export default {
  name: 'AuthenticationDialog',
  computed: {
    phoneVerifyCodeText() {
      if (!this.isLock) {
        return '获取验证码';
      }
      return `${this.countdown}S后可重新获取`;
    },
  },
  data() {
    return {
      visible: false,
      isLock: false, // 锁
      phoneNum: '', // 手机号
      phoneVerifyCode: '', // 验证码
      countdown: 60, // 倒计时
      timer: null, // 定时器
    };
  },
  methods: {
    // 获取验证码
    async getVerificationCode() {
      // 开启锁之后不再走当前方法
      if (this.isLock) {
        return;
      }
      this.isLock = true;
      this.runCountdown();
      const { data = {} } = await getPhoneCodeForTjSession();
      if (data.status === 'success') {
        this.phoneNum = data?.phoneNum || '';
      } else {
        if (data?.message) {
          this.$message.warning(data.message);
        }
        setTimeout(() => {
          this.resetDefault();
        }, 1000);
      }
    },
    resetDefault() {
      this.countdown = 60;
      this.isLock = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    // 开启倒计时
    runCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.resetDefault();
        }
        this.countdown--;
      }, 1000);

      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.timer);
      });
    },
    // 验证
    async onSubmit() {
      // 用全等  相对等于如果遇到验证为 000000 会存在问题
      if (this.phoneVerifyCode === '') {
        this.$message.warning('请输入验证码');
        return;
      }

      const { data = {} } = await checkPhoneVerifyCodeForTj({ phoneVerifyCode: this.phoneVerifyCode });
      if (data?.status === 'success') {
        this.$message.success('验证成功！');
        this.close();
      } else {
        this.$message.warning('验证失败！');
      }
    },
    // 打开弹框
    show() {
      this.visible = true;
    },
    // 关闭弹框
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  min-height: 80px !important;
}
.authentication-container {
  text-align: center;
  .el-button {
    width: 110px;
    padding: 6px;
    margin-left: 10px;
  }
}
.verify-code-info {
  text-align: left;
  margin-left: 24px;
  margin-top: 10px;
  font-size: 12px;
  color: green;
}
.authentication-btn-container {
  text-align: center;
  .el-button {
    width: 270px;
    padding: 8px 0;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
